var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-icon24x24',{attrs:{"title":_vm.title}},[_c('path',{attrs:{"d":"M1.845 1l-0.845 0.845 10.155 10.155-10.155 10.156 0.845 0.845 10.155-10.156 10.156 10.155 0.845-0.845-10.156-10.155 10.155-10.155-0.845-0.845-10.155 10.155z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }